import {Pipe, PipeTransform} from '@angular/core';
import {RankScheduleDto} from '../../../Models/Rrhh/Schedules/schedule.interface';

@Pipe({
  name: 'schedules',
  standalone: false
})
export class SchedulesPipe implements PipeTransform {

  transform(items: RankScheduleDto[], filter: { id_departamento?: number, id_user?: number, id_servicio?: number }): RankScheduleDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.id_departamento) {
      items = items.filter((item) => item['id_departamento'] == filter.id_departamento);
    }

    if (filter.id_user) {
      items = items.filter((item) => item['id_usuario'] == filter.id_user);
    }

    if (filter.id_servicio) {
      items = items.filter((item) => item['id_servicio'] == filter.id_servicio);
    }

    return items;

  }

}
